// extracted by mini-css-extract-plugin
export default {"contextMenu":"play-property-context-menu_contextMenu__wlzuF"};